import { InputTypes } from "../InputTypes";
import { Address } from "./Address";
import { InternalNotes } from "./InternalNotes";
import { SimpleProduct } from "./SimpleProduct";
import { Status } from "./Status";

export const Order = Object.freeze({
  products: {
    visibleName: "Productos",
    type: InputTypes.POPUP_ARRAY,
    array: {
      name: "products",
      type: InputTypes.COMPOSED,
      composedElements: SimpleProduct,
      preview: "name",
    },
  },
  amount: {
    visibleName: "Precio total",
    type: InputTypes.NUMBER,
    min: 0,
    step: 0.01,
  },
  currency: {
    visibleName: "Moneda",
    type: InputTypes.TEXT,
  },
  delivery_address: {
    visibleName: "Dirección de envío",
    name: "delivery_address",
    type: InputTypes.COMPOSED,
    composedElements: Address,
  },
  invoice_address: {
    visibleName: "Dirección de facturación",
    name: "invoice_addresses",
    type: InputTypes.COMPOSED,
    composedElements: Address,
  },
  status: {
    visibleName: "Estado",
    type: InputTypes.POPUP_ARRAY,
    array: {
      name: "status",
      preview: "status",
      type: InputTypes.COMPOSED,
      composedElements: Status,
    },
  },
  internal_notes: {
    visibleName: "Notas internas",
    type: InputTypes.POPUP_ARRAY,
    array: {
      name: "internal_notes",
      preview: "note",
      type: InputTypes.COMPOSED,
      composedElements: InternalNotes,
    },
  },
});
